import {merge} from '../clone';
import isObject from './isObject';

/**
 * @public
 * Builds one-level-depth object by moving all nested properties to the first level.
 *
 * @see https://gist.github.com/jherax/18bccbf10f00a8565544
 *
 * @param  {Object}  obj: the object to transform
 * @param  {Boolean} lowercase: (optional) Determines if each property name should be lowercase
 * @param  {String}  prefix: (optional) Sets a prefix for the object to transform
 * @return {Object}  Object generated with one-level-depth
 */
export default function toOneLevelDepth(obj, lowercase, ...args) {
  const prefix = args[0];
  const newObj = {};
  let key, value, newKey;
  if (isObject(obj)) { // object and array
    for (key in obj) {
      value = obj[key];
      // prevents save empty values
      if (value === '' || value == null) continue;
      if (!prefix) newKey = key;
      else newKey = `${prefix}-${key}`;
      if (lowercase === true) newKey = newKey.toLowerCase();
      if (isObject(value)) { // objects and arrays
        // recursively iterates over properties/items
        merge(newObj, toOneLevelDepth(value, lowercase, newKey));
      } else {
        newObj[newKey] = value;
      }
    } // end for
  } // end if
  return newObj;
}
